import React from 'react';
import { Row, Col } from 'react-bootstrap';
import DwriVariabilityFactorTable from './DwriVariabilityFactorTable';
import '../../dwri.css';

const DwriSystemVariabilityFactors = ({ pwsId, years = [], variabilityFactors = [], loading, error, onSaved }) => {

  if (error) return <p className="text-danger">Error loading System Variability Factors</p>;
  if (loading) return <p>Loading...</p>;

  const findFactor = (type) => variabilityFactors.find((factor) => factor.type === type);

  return (
    <>
      <Row>
        <Col><span><b>System Variability Factors</b></span></Col>
      </Row>
      <DwriVariabilityFactorTable
        type="peakDay"
        label="Peak Day Demand per ERC"
        pwsId={pwsId}
        years={years}
        factor={findFactor('peakDay')}
        onSaved={onSaved}
      />
      <br />
      <DwriVariabilityFactorTable
        type="averageAnnual"
        label="Average Annual Demand per ERC"
        pwsId={pwsId}
        years={years}
        factor={findFactor('averageAnnual')}
        onSaved={onSaved}
      />
      <br />
      <DwriVariabilityFactorTable
        type="equalizationStorage"
        label="Equalization Storage per ERC"
        pwsId={pwsId}
        years={years}
        factor={findFactor('equalizationStorage')}
        onSaved={onSaved}
      />
    </>
  );
};

export default DwriSystemVariabilityFactors;
